import React from "react";

const WebDev = () => {
  return <h1>Practice</h1>;
};

export default WebDev;